"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { ArrowRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export const projects = [{
  title: "Pershing 56",
  description: "Capacità 12 persone, Crew 2. Velocità e lusso senza compromessi.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673241/img/yacht_pershing_56_gold.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673241/img/yacht_pershing_56_gold.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673241/img/yacht_pershing_56_gold.png-wvc-sizes",
    alt: "Pershing 56"
  },
  link: "/CollectionGoldPage",
  price: 4125
}, {
  title: "Sunseeker 56",
  description: "Capacità 12 persone, Crew 1. Design iconico e ampi spazi esterni.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673241/img/yacht_sunseeker_56_luxury.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673241/img/yacht_sunseeker_56_luxury.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673241/img/yacht_sunseeker_56_luxury.png-wvc-sizes",
    alt: "Sunseeker 56"
  },
  link: "/CollectionGoldPage",
  price: 3850
}, {
  title: "NOAH 29",
  description: "Capacità 12 persone. Agilità e stile per esplorare le calette più nascoste.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673241/img/yacht_noah_29_rib.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673241/img/yacht_noah_29_rib.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673241/img/yacht_noah_29_rib.png-wvc-sizes",
    alt: "NOAH 29"
  },
  link: "/CollectionGoldPage",
  price: 1200
}, {
  title: "Sunseeker Mohawk 29",
  description: "Capacità 8 persone. Un classico intramontabile per giornate indimenticabili.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673241/img/yacht_sunseeker_mohawk_29.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673241/img/yacht_sunseeker_mohawk_29.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673241/img/yacht_sunseeker_mohawk_29.png-wvc-sizes",
    alt: "Sunseeker Mohawk 29"
  },
  link: "/CollectionGoldPage",
  price: 1450
}, {
  title: "Wajer 38S",
  description: "Capacità 11 persone. L'eccellenza olandese nel design e nelle prestazioni.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673241/img/yacht_wajer_38s_sport.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673241/img/yacht_wajer_38s_sport.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673241/img/yacht_wajer_38s_sport.png-wvc-sizes",
    alt: "Wajer 38S"
  },
  link: "/CollectionGoldPage",
  price: 2900
}, {
  title: "De Antonio 34",
  description: "Capacità 11 persone. Innovazione e comfort con motori fuoribordo nascosti.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673241/img/yacht_de_antonio_34_open.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673241/img/yacht_de_antonio_34_open.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673241/img/yacht_de_antonio_34_open.png-wvc-sizes",
    alt: "De Antonio 34"
  },
  link: "/CollectionGoldPage",
  price: 2600
}, {
  title: "Oryx 38",
  description: "Capacità 12 persone. Sportività e versatilità per il mare di Ibiza.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673241/img/yacht_oryx_38_cruiser.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673241/img/yacht_oryx_38_cruiser.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673241/img/yacht_oryx_38_cruiser.png-wvc-sizes",
    alt: "Oryx 38"
  },
  link: "/CollectionGoldPage",
  price: 2100
}, {
  title: "VanDutch 40",
  description: "Capacità 10 persone. L'essenza del minimalismo e dell'eleganza moderna.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673241/img/yacht_vandutch_40_classic.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673241/img/yacht_vandutch_40_classic.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673241/img/yacht_vandutch_40_classic.png-wvc-sizes",
    alt: "VanDutch 40"
  },
  link: "/CollectionGoldPage",
  price: 3200
}, {
  title: "Vanquish VQ40",
  description: "Capacità 11 persone. Potenza e stile audace per chi non vuole passare inosservato.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673241/img/yacht_vanquish_vq40_sport.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673241/img/yacht_vanquish_vq40_sport.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673241/img/yacht_vanquish_vq40_sport.png-wvc-sizes",
    alt: "Vanquish VQ40"
  },
  link: "/CollectionGoldPage",
  price: 3500
}, {
  title: "Fjord 40",
  description: "Capacità 12 persone. Design architettonico e ampi spazi prendisole.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673241/img/yacht_fjord_40_open_gold.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673241/img/yacht_fjord_40_open_gold.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673241/img/yacht_fjord_40_open_gold.png-wvc-sizes",
    alt: "Fjord 40"
  },
  link: "/CollectionGoldPage",
  price: 2800
}, {
  title: "Vanquish VQ45",
  description: "Capacità 12 persone, Crew 1. Il perfetto equilibrio tra velocità e comfort.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673241/img/yacht_vanquish_vq45_luxury.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673241/img/yacht_vanquish_vq45_luxury.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673241/img/yacht_vanquish_vq45_luxury.png-wvc-sizes",
    alt: "Vanquish VQ45"
  },
  link: "/CollectionGoldPage",
  price: 3900
}, {
  title: "Riva Rivale 56",
  description: "Capacità 12 persone, Crew 2. L'eccellenza del Made in Italy sull'acqua.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673241/img/yacht_riva_rivale_56_prestige.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673241/img/yacht_riva_rivale_56_prestige.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673241/img/yacht_riva_rivale_56_prestige.png-wvc-sizes",
    alt: "Riva Rivale 56"
  },
  link: "/CollectionGoldPage",
  price: 4500
}];
export default function Projects() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="264088" id="luxuryyachtfleet" className="bg-background text-foreground py-20">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 text-center">
          <h2 className="font-default text-foreground mb-4 text-3xl font-bold tracking-tight sm:text-5xl uppercase">
            La Flotta di Yacht di Lusso
          </h2>
          <p className="text-muted-foreground font-sans mx-auto max-w-2xl text-lg">
            Esplora la nostra selezione curata di imbarcazioni di classe mondiale, dove il minimalismo 
            architettonico incontra la libertà sconfinata del mare aperto.
          </p>
        </div>

        <div ref={ref} className={`grid grid-cols-1 gap-8 sm:grid-cols-2 md:grid-cols-3 transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          {projects.map((project, index) => <div data-index={index} key={index} className="flex h-full">
              <Card className="border-border/30 bg-card group flex h-full w-full flex-col overflow-hidden rounded-md border transition-all duration-500 hover:-translate-y-2 hover:border-secondary hover:shadow-xl">
                <div className="overflow-hidden">
                  <AspectRatio ratio={16 / 9}>
                    <img src={project.image.src} data-wvc-srcset={project.image.srcset} data-wvc-sizes={project.image.sizes} alt={project.image.alt} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" />
                  </AspectRatio>
                </div>
                <CardHeader className="flex-none pb-4">
                  <div className="flex justify-between items-start mb-2">
                    <span className="text-xs font-bold tracking-widest text-secondary uppercase">Ibiza</span>
                    <span className="text-sm font-bold text-primary">Da €{project.price.toLocaleString('it-IT')}/giorno</span>
                  </div>
                  <CardTitle className="font-default text-foreground text-2xl font-bold leading-tight uppercase tracking-tight">
                    {project.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="flex-grow pb-6">
                  <CardDescription className="font-sans text-muted-foreground text-base leading-relaxed">
                    {project.description}
                  </CardDescription>
                </CardContent>
                <CardFooter className="mt-auto pt-0">
                  <Button asChild variant="outline" className="w-full rounded-md border-primary text-primary font-bold uppercase tracking-widest transition-all duration-300 group-hover:bg-primary group-hover:text-primary-foreground">
                    <Link to="/ContactsPage">
                      Prenota Consulenza
                      <ArrowRight className="ml-2 h-4 w-4" />
                    </Link>
                  </Button>
                </CardFooter>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}